// src/data/lists.js

export const categoriesList = {
  Action: 'אקשן',
  Adventure: 'הרפתקאות',
  'Avant Garde': 'אנימה ניסיונית',
  'Award Winning': 'זוכה פרס',
  'Boys Love': 'אהבת בנים',
  Comedy: 'קומדיה',
  Drama: 'דרמה',
  Fantasy: 'פנטזיה',
  'Girls Love': 'אהבת בנות',
  Gourmet: 'בישול',
  Horror: 'אימה',
  Mystery: 'מסתורין',
  Romance: 'רומנטיקה',
  'Sci-Fi': 'מדע בדיוני',
  'Slice of Life': 'חלק מהחיים',
  Sports: 'ספורט',
  Supernatural: 'על טבעי',
  Suspense: 'מתח',
  'Adult Cast': 'קהל בוגר',
  Anthropomorphic: 'האנשה',
  CGDCT: 'בנות חמודות',
  Childcare: 'טיפול בילדים',
  'Combat Sports': 'קרבות ספורט',
  Crossdressing: 'הלבשה',
  Delinquents: 'עבריינות',
  Detective: 'בלשות',
  Educational: 'חינוכי',
  'Gag Humor': 'קומדיה הומוריסטית',
  Gore: 'גור',
  Harem: 'הרמון (נשים)',
  'High Stakes Game': 'משחקי מזל',
  Historical: 'היסטורי',
  'Idols (Female)': 'מפורסמת',
  'Idols (Male)': 'מפורסם',
  Isekai: 'עולם אחר',
  Iyashikei: 'מצב ריפוי',
  'Love Polygon': 'אהבה יותר מאישה אחת',
  'Love Status Quo': 'משולש אהבה',
  'Magical Sex Shift': 'שינוי מגדרי קסום',
  'Mahou Shoujo': 'ילדות קסומות',
  'Martial Arts': 'אומנויות לחימה',
  Mecha: 'רובוטים',
  Medical: 'רפואה',
  Military: 'צבאי',
  Music: 'מוזיקה',
  Mythology: 'מיתולוגיה',
  'Organized Crime': 'פשע מאורגן',
  'Otaku Culture': 'תרבות האוטקו',
  Parody: 'פרודיה',
  'Performing Arts': 'אמנות במה',
  Pets: 'חיות',
  Psychological: 'פסיכולוגיה',
  Racing: 'מרוצים',
  Reincarnation: 'חזר לחיים',
  'Reverse Harem': 'הרמון (גברים)',
  Samurai: 'סמוראי',
  School: 'בית ספר',
  Showbiz: 'תעשיית הבידור',
  Space: 'חלל',
  'Strategy Game': 'משחק אסטרטגיה',
  'Super Power': 'כוחות מיוחדים',
  Survival: 'הישרדות',
  'Team Sports': 'ספורט קבוצתי',
  'Time Travel': 'מסע בזמן',
  'Urban Fantasy': 'פנטזיה אורבנית',
  Vampire: 'ערפדים',
  'Video Game': 'משחק מחשב',
  Villainess: 'נבלות',
  'Visual Arts': 'אומנות חזותית',
  Workplace: 'מקום עבודה',
}

export const animesList = ['דרגון בול', 'וואן פיס', 'נאורוטו']

export const charactersWithQuotes = {
  גוקו: ['גוקו: אני סופר סאיין!', 'גוקו: לעולם לא לוותר!'],
  זורו: ['זורו: אני אהיה החרב הטובה בעולם!', 'זורו: ללא כבוד אין משמעות!'],
}
